
import { defineComponent, reactive } from 'vue'
import { useRouter } from 'vue-router'

import api from '@/store/api'

export default defineComponent({
  setup() {
    const router = useRouter()
    const data = reactive({
      email: ''
    })

    const formSubmitted = () => {
      api
        .call(
          'POST',
          'system_users_password_reset_request',
          {
            email: data.email
          },
          false
        )
        .then(() => {
          router.push('/login?reset-link-sent')
        })
    }

    const loginClicked = () => {
      router.push('/login')
    }

    return {
      formSubmitted,
      data,
      loginClicked
    }
  }
})
